import { IImage } from "@faire/web-api--source/indigofair/data/IImage";

type LoadingPageImage = {
  topLeft: Partial<IImage>[];
  topRight: Partial<IImage>[];
  bottomLeft: Partial<IImage>[];
  bottomRight: Partial<IImage>[];
};

export const foodAndBeverageImages: LoadingPageImage = {
  topLeft: [
    {
      url: "https://cdn.faire.com/fastly/c6afd965cd0007feb459df828c3f0ea989ab95686e54b4daf410a6000a2d45ca.png",
    },
    {
      url: "https://cdn.faire.com/fastly/d6093158470fc712a03392b19fa5d21c310369090dc023d9740ae569949d7bfa.png",
    },
  ],
  topRight: [
    {
      url: "https://cdn.faire.com/fastly/7a106fdaae7611ece721e6a9101df6701877e21e2073874e6867fa9ce05fe1e0.jpeg",
    },
    {
      url: "https://cdn.faire.com/fastly/1c042da25a7f5f7126c3fda52bec1eb51ef729fa1fdc5bc7a9d04e734c43b70b.jpeg",
    },
  ],
  bottomLeft: [
    {
      url: "https://cdn.faire.com/fastly/86f17531e965198ada42b9447e1eb2a1dcea4c47be2444bfb37a6dc4c385687f.jpeg",
    },
    {
      url: "https://cdn.faire.com/fastly/aac8961e59f83b76743a824f68cf425452011ff2e6e113f78829d9201de3ec44.png",
    },
  ],
  bottomRight: [
    {
      url: "https://cdn.faire.com/fastly/30318755a92b871120e1035bc220689a0f34802f419b5e1046344ddd2c5f8420.jpeg",
    },
    {
      url: "https://cdn.faire.com/fastly/d4cfd8dc5bc7bb3a76bebdb12ca1d39c7450e97a3becced13241a3f3981c174f.jpeg",
    },
  ],
};
